import { render, staticRenderFns } from "./itemTalk.vue?vue&type=template&id=69b2f0e5&scoped=true"
import script from "./itemTalk.vue?vue&type=script&lang=js"
export * from "./itemTalk.vue?vue&type=script&lang=js"
import style0 from "./itemTalk.vue?vue&type=style&index=0&id=69b2f0e5&prod&lange=less&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b2f0e5",
  null
  
)

export default component.exports